import { displayException } from 'sdi/app';
import { configure, defaultShape, IShape } from 'sdi/shape';
import { AppConfigIO, getMessage, source } from 'sdi/source';
import { app } from './app';
import './locale';
import { defaultAppShape } from './shape/app';
import { defaultMapState } from './shape/map';
import { defaultTableShape } from './shape/table';
import { defaultQaShape } from './shape/qa';

export const main = (SDI: unknown) =>
    AppConfigIO.decode(SDI).fold(
        errors => {
            const textErrors = errors.map(e => getMessage(e.value, e.context));
            displayException(textErrors.join('\n'));
        },
        config => {
            const initialState: IShape = {
                ...defaultShape(config),
                ...defaultAppShape(),
                ...defaultMapState(),
                ...defaultTableShape(),
                ...defaultQaShape(),
                'app/codename': 'qa',
                'app/lang': 'fr',
            };

            const stateActions = source<IShape>([]);
            const store = stateActions(initialState);
            configure(store);

            const start = app(config.args)(store);
            start();
        }
    );
